export enum IndicadorServicio {
   "BoletasServicioPeriodico" = 1,
   "BoletasServicioPeriodicoDomiciliario" = 2,
   "BoletasVentaYServicios" = 3,
   "BoletaEspectaculoEmitidaTerceros" = 4,
}

export enum IndicadorServicioExportacion {
  SinEspecificar = 0,
  FacturaServiciosPeriodicosDomiciliarios = 1,
  //FacturaOtrosServiciosPeriodicos = 2,
  FacturaServicios = 3,
  ServiciosHoteleria = 4,
  ServicioTransporteTerrestreInternacional = 5,
  ServiciosPrestadosYUtilizadosTotalmenteEnElExtranjero = 6,
}

export const INDICADORES_SERVICIO_LOCAL_EXPORTACION = [
  { value: IndicadorServicioExportacion.ServiciosHoteleria, label: 'Servicios de Hotelería' },
  { value: IndicadorServicioExportacion.ServicioTransporteTerrestreInternacional, label: 'Servicio de Transporte Terrestre Internacional' },
  { value: IndicadorServicioExportacion.ServiciosPrestadosYUtilizadosTotalmenteEnElExtranjero, label: 'Servicios prestados y utilizados totalmente en el extranjero' },
];

export function esIndicadorServicioLocalExportacion(valor: number | null | undefined): boolean {
  return INDICADORES_SERVICIO_LOCAL_EXPORTACION.some((indicador) => indicador.value === valor);
}
